import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import _ from 'lodash';
import { css } from '@emotion/react';

import { PRODUCT_CODE, getFetcher } from '../../../../App';
import { PrimaryButton, Sub1Button, Switch } from '@components/atoms';
import { dialogContentsState } from '@components/templates/Dialog';
import SettingCommonMethods from '../../../../utils/settingCommon';
import { useCatchLeave } from '../../../../utils/hooks';
import { StyledReportWrap, StyledSMWIArea, StyledSMWIFlex, StyledNotice, StyledSwButtonSection } from './style';
import { submitDebounce } from 'utils/lib';

const NIPDOption = () => {
  const [switchIndex, setSwitchIndex] = useState(0);
  const [SMWIData, setSMWIData] = useState({ isGsmwi: false });
  const [originData, setOriginData] = useState({ isGsmwi: false });
  const [isChanged, setIsChanged] = useState(false);
  const setDialogContents = useSetRecoilState(dialogContentsState);
  const { errorHandler } = SettingCommonMethods();

  // 값 변경이 있는 경우 새로고침, 탭닫기 막기
  useCatchLeave(isChanged);

  /**
   * api 가져오기
   */
  const getOptionSetting = async () => {
    const url = PRODUCT_CODE === 'mn1q' ? `api/setting/ni/option` : `api/setting/ipd/option`;
    const token = localStorage.getItem('PROD_ADMIN_ACCESS_TOKEN') || undefined;

    await getFetcher({
      method: 'GET',
      accessToken: token,
    })(url)
      .then((r) => {
        if (r.code === '200') {
          setSMWIData({ isGsmwi: r.result.isGsmwi });
          setOriginData({ isGsmwi: r.result.isGsmwi });
        } else {
          errorHandler(r);
        }
      })
      .catch((e) => {
        console.log(e, 'e');
      });
  };

  /**
   * 변경사항 있는 경우 알림발생
   */
  const isChangeSetting = async (e: boolean) => {
    const turn = e && !SMWIData.isGsmwi ? 'on' : 'off';

    setDialogContents({
      type: 'plain',
      body: `Are you sure you want to turn ${turn}? \n\r(You must click Submit for the changes to take effect.)`,
      footer: (
        <>
          <Sub1Button
            onClick={() => {
              setSwitchIndex(switchIndex + 1);
              setDialogContents({ type: 'hidden' });
            }}
          >
            {`No, I don't`}
          </Sub1Button>
          <PrimaryButton
            onClick={async () => {
              await setSMWIData({ isGsmwi: e });
              setDialogContents({ type: 'hidden' });
            }}
          >
            Yes, turn {turn}
          </PrimaryButton>
        </>
      ),
    });
  };

  /**
   *  변경값 저장
   */
  const postSMWISetting = async () => {
    const url = PRODUCT_CODE === 'mn1q' ? `api/setting/ni/option` : `api/setting/ipd/option`;
    const token = localStorage.getItem('PROD_ADMIN_ACCESS_TOKEN') || undefined;
    const _tmpBody = { isGsmwi: SMWIData.isGsmwi };

    await getFetcher({
      method: 'POST',
      accessToken: token,
      body: _tmpBody,
    })(url)
      .then(async (r) => {
        if (r.code === '200') {
          setDialogContents({
            type: 'plain',
            body: `It has been reflected.`,
            footer: (
              <PrimaryButton
                onClick={async () => {
                  setDialogContents({ type: 'hidden' });
                }}
              >
                OK
              </PrimaryButton>
            ),
          });
          setOriginData(_tmpBody);
        } else {
          errorHandler(r);
        }
      })
      .catch((e) => {
        console.log(e, 'e');
      });
  };

  useEffect(() => {
    getOptionSetting();
  }, []);

  useEffect(() => {
    if (JSON.stringify(SMWIData) !== JSON.stringify(originData)) {
      setIsChanged(true);
    } else if (JSON.stringify(SMWIData) === JSON.stringify(originData)) {
      setIsChanged(false);
    }
  }, [SMWIData, originData]);

  return (
    <>
      <label>Option</label>
      <StyledReportWrap>
        <StyledSMWIArea>
          <strong>SMWI Analysis</strong>
          <StyledSMWIFlex>
            <span className={'send-title'}>
              Analyzes the <strong>G.SMWI</strong> images.
              <StyledNotice>
                <p>H.SMWI : Image in accordance with the protocol.</p>
                <p>G.SMWI : Image not in accordance with protocol.</p>
              </StyledNotice>
            </span>
            <div>
              <span className={'send-off'}>Off</span>
              <Switch key={switchIndex} defaultValue={SMWIData.isGsmwi} onChangeValue={(e) => isChangeSetting(e)} />
              <span className={'send-on'}>On</span>
            </div>
          </StyledSMWIFlex>
        </StyledSMWIArea>
      </StyledReportWrap>

      <StyledSwButtonSection>
        <PrimaryButton
          styles={css`
            width: 145px;
            height: 48px;
            margin-top: 8px;
            font-size: 18px;
          `}
          onClick={submitDebounce(() => postSMWISetting())}
          disabled={!isChanged}
        >
          Submit
        </PrimaryButton>
      </StyledSwButtonSection>
    </>
  );
};

export default NIPDOption;
